import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import { getProductCardIconWithTooltip } from '../../utils/productCardUtils';
import { sortInteriors } from 'rangeConfig/jonaxel/sorting/sort';
import { matchInteriorsToFrames } from 'rangeConfig/jonaxel/filters/matchInteriorsToFrames';

const interiorsProductListConfig: ProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: 'typeName, designText',
  infoButtonAriaLabel: 'storageone.productListInteriorsTitle',
  sortClusteredProducts: sortInteriors,
  sortOrder: [{ path: 'name' }],
  categories: [
    {
      id: 'jonaxel-basket',
      products: [
        { path: 'type', value: ProductType.JONAXEL_MESH_BASKET },
        { path: 'type', value: ProductType.JONAXEL_WIRE_BASKET }
      ]
    },
    {
      id: 'jonaxel-other',
      products: [
        { path: 'type', value: ProductType.JONAXEL_TOP_SHELF },
        { path: 'type', value: ProductType.JONAXEL_CLOTH_RAIL_ADJUSTABLE }
      ]
    }
  ],
  productFilters: [matchInteriorsToFrames],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: ['type'],
  productCardIcon: getProductCardIconWithTooltip
};

export default interiorsProductListConfig;
